import axios, { LONG_TIMEOUT_MS } from "utils/axios";

export const getInits = () => {
  return axios.get("/WA/inits");
};

export const getInitsTicket = () => {
  return axios.get("/WA/tickets/init");
};

export const getTickets = (params) => {
  return axios.get("/WA/tickets", { params });
};

// export tickets ke file xlsx/csv, filter-nya sama persis dengan getTickets
export const exportTickets = (params) => {
  return axios.get("/WA/tickets/export", {
    params,
    responseType: "blob",
    timeout: LONG_TIMEOUT_MS,
  });
};

// get ticket tags
export const getTicketTags = () => {
  return axios.get("/WA/tickets/tags");
};

// get ticket by id
export const getTicketById = (id) => {
  return axios.get(`/WA/tickets/${id}`);
};

// create ticket
export const createTicket = (payload) => {
  return axios.post("/WA/tickets", payload);
};

export const postCommentTicket = (id, payload) => {
  return axios.post(`/WA/tickets/${id}/comments`, payload);
};

export const deleteCommentTicket = (id) => {
  return axios.delete(`/WA/tickets/comments/${id}`);
};

export const updateTicket = (id, payload) => {
  return axios.put(`/WA/tickets/${id}`, payload);
};

export const getTabFilters = () => {
  return axios.get("/WA/tickets/filters");
};

export const createTabFilter = (payload) => {
  return axios.post("/WA/tickets/filters", payload);
};

export const updateTabFilter = (id, payload) => {
  return axios.put(`/WA/tickets/filters/${id}`, payload);
};

export const deleteTabFilter = (id) => {
  return axios.delete(`/WA/tickets/filters/${id}`);
};

export const postTagTicketing = (payload) => {
  return axios.post("/WA/tickets/tags", payload);
};

export const deleteTicket = (id) => {
  return axios.delete(`/WA/tickets/${id}`);
};

// inbox ticketing
export const getInboxTicketing = (params) => {
  return axios.get("/WA/tickets/inboxes", { params });
};

export const createInboxTicketing = (payload) => {
  return axios.post("/WA/tickets/inboxes", payload);
};

export const updateInboxTicketing = (id, payload) => {
  return axios.put(`/WA/tickets/inboxes/${id}`, payload);
};

export const deleteInboxTicketing = (id) => {
  return axios.delete(`/WA/tickets/inboxes/${id}`);
};
